export default "__VITE_ASSET__qNtL6Iu6__"